export default "Optimisation TURPE exploitation agricole — Acheminement électricité | Solution Éco France";
